import React, { useState } from 'react';
import { Row, Col, Nav, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers, faShieldAlt, faUserTag, faTh
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../component/header/header';
import Sidebar from '../../component/sidebar/sidebar';
import UsersList from './components/UsersList';
import UserPermissionsPage from './components/UserPermissionsPage';
import RolesList from './components/RolesList';
import CapabilitiesList from './components/CapabilitiesList';
import {
  useUsers,
  useRoles,
  useCapabilities,
  useResourceTypes,
} from './hooks/useAuthorizationData';
import './Authorization.css';

const Authorization = () => {
  const [activeTab, setActiveTab] = useState('users');
  const [selectedUser, setSelectedUser] = useState(null);

  const { data: users, isLoading: usersLoading, refetch: refetchUsers } = useUsers();
  const { data: roles, isLoading: rolesLoading, refetch: refetchRoles } = useRoles();
  const { data: capabilities, isLoading: capsLoading } = useCapabilities();
  const { data: resourceTypes } = useResourceTypes();

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setActiveTab('user-permissions');
  };

  const handleBackFromUser = () => {
    setSelectedUser(null);
    setActiveTab('users');
  };

  return (
    <div className="auth-module-page">
      <Row className="flex-nowrap m-0 p-0">
        <Col xs={2} className="sidebar-container p-0">
          <Sidebar activePage="authorization" />
        </Col>

        <Col xs={10} className="content-area p-0">
          <div style={{ position: 'sticky', top: 0, zIndex: 999 }}>
            <Header />
          </div>

          <div className="content-wrapper">
            <div className="auth-page-header">
              <h1>Authorization & Permissions</h1>
              <p>Manage roles, capabilities, and access control for your ESG platform</p>
            </div>

            <Tab.Container
              activeKey={activeTab}
              onSelect={(k) => {
                if (k !== 'user-permissions') setSelectedUser(null);
                setActiveTab(k);
              }}
            >
              {activeTab !== 'user-permissions' && (
                <Nav variant="tabs" className="auth-main-tabs mb-0">
                  <Nav.Item>
                    <Nav.Link eventKey="users">
                      <FontAwesomeIcon icon={faUsers} className="me-2" />
                      Users
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="roles">
                      <FontAwesomeIcon icon={faUserTag} className="me-2" />
                      Roles
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="capabilities">
                      <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
                      Capabilities
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              )}

              <Tab.Content>
                <Tab.Pane eventKey="users">
                  {activeTab === 'users' && (
                    <UsersList
                      users={users}
                      isLoading={usersLoading}
                      onSelectUser={handleSelectUser}
                    />
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey="user-permissions">
                  {activeTab === 'user-permissions' && selectedUser && (
                    <UserPermissionsPage
                      user={selectedUser}
                      resourceTypes={resourceTypes}
                      onBack={handleBackFromUser}
                    />
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey="roles">
                  {activeTab === 'roles' && (
                    <RolesList
                      roles={roles}
                      allCapabilities={capabilities}
                      isLoading={rolesLoading}
                      onRefetch={refetchRoles}
                    />
                  )}
                </Tab.Pane>

                <Tab.Pane eventKey="capabilities">
                  {activeTab === 'capabilities' && (
                    <CapabilitiesList
                      capabilities={capabilities}
                      isLoading={capsLoading}
                      resourceTypes={resourceTypes}
                    />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Authorization;